<template>
    <aside class="app-nav-panel">
        <div class="content-wrap">
            <div class="brand">
                <div class="brand-mark">
                    <img src="./../assets/images/logo.png">
                    <span class="brand-version">2.0</span>
                </div>
                <div>
                    <p>World of Warcraft</p>
                    <h1>Raider.io Dashboard</h1>
                </div>
            </div>

            <div class="nav-section">
                <p class="nav-title">Navigation</p>
                <nav class="nav-list" aria-label="Main navigation">
                    <router-link
                        v-for="item in navItems"
                        :key="item.to"
                        :to="item.to"
                        class="nav-item"
                    >
                        <span class="nav-item-icon" aria-hidden="true">
                            <i :class="item.icon"></i>
                        </span>
                        <span class="nav-item-copy">
                            <span class="text">{{ item.label }}</span>
                            <span class="hint">{{ item.hint }}</span>
                        </span>
                    </router-link>
                </nav>
            </div>

            <div class="nav-bottom">
                <div class="nav-footer-card" aria-label="Dashboard controls">
                    <div class="scope-card">
                        <span>Data scope</span>
                        <strong>{{ activeSeasonLabel }}</strong>
                    </div>
                    <router-link class="nav-control-icon" to="/settings" aria-label="Open settings" title="Settings">
                        <i class="fa-solid fa-gear"></i>
                    </router-link>
                </div>
            </div>
        </div>
    </aside>
</template>

<script>
export default {
    name: 'AppNavPanel',
    props: {
        navItems: {
            type: Array,
            default() {
                return []
            }
        },
        updateAvailable: {
            type: Boolean,
            default: false
        },
        activeSeasonLabel: {
            type: String,
            default: 'MN1'
        },
        isDarkMode: {
            type: Boolean,
            default: false
        }
    },
    emits: ['toggleTheme', 'checkUpdates']
}
</script>
